export default __webpack_public_path__ + "static/media/good-icon.0336af88.svg";